module.exports = __webpack_public_path__ + "media/images/emblems/Jouxtens-Mezery-coat_of_arms-a42c3364d89fc2e2a85266d63788725b.svg";